import type React from 'react';

const ThisWaySvgIcon: React.FC<React.SVGAttributes<SVGElement>> = () => {
  return (
    <svg width="129" height="76" viewBox="0 0 129 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_274_1078)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.19727 8.40314V1.39435H29.6266V8.40314H19.4099V35.9434H11.414V8.40314H1.19727Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.1875 35.9434V1.39435H40.1834V14.6219H53.509V1.39435H61.5049V35.9434H53.509V22.0248H40.1834V35.9434H32.1875Z"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M67.4766 35.9436H75.4725V1.39453H67.4766V35.9436Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.583 25.5293C107.583 28.6877 106.448 31.353 104.128 33.4757C101.807 35.5984 98.649 36.6341 94.6025 36.6341C86.5085 36.6341 81.4739 32.8836 79.4502 25.4303L86.2115 22.1729C87.4461 27.1085 89.9126 29.6262 94.6025 29.6262C97.7114 29.6262 99.7351 28.0956 99.7351 26.0728C99.7351 23.5056 97.3164 21.9758 91.9858 20.9887C84.7313 19.5571 81.1284 16.1026 81.1284 10.6244C81.1284 7.61361 82.2631 5.24435 84.5334 3.4177C86.8045 1.59194 89.8145 0.703796 93.5659 0.703796C100.327 0.703796 104.572 3.61566 106.99 9.73542L101.018 13.2897C99.637 9.24231 97.1184 7.21859 93.4174 7.21859C90.4561 7.21859 88.3342 8.55124 88.3342 10.5255C88.3342 12.4502 90.5541 13.7829 96.5263 15.0165C104.177 16.6452 107.583 19.8045 107.583 25.5293Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1806 75.7804L0.703613 41.2313H9.14403L13.7827 60.4805C14.1786 62.2073 14.4746 63.54 14.6222 64.3795L15.4123 60.431L20.2489 41.2313H28.5408L33.3774 60.431L34.1675 64.3795L35.0061 60.4805L39.6457 41.2313H48.0861L38.6091 75.7804H30.1695L24.3944 53.2252L18.6202 75.7804H10.1806Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.1729 75.7804L59.239 41.2313H66.7409L80.808 75.7804H72.121L69.0121 67.439H56.9688L53.8598 75.7804H45.1729ZM61.5597 55.0015L59.4856 60.6281H66.4944L64.4212 55.0015C63.8786 53.6688 63.4349 52.2867 62.9904 50.9054L61.5597 55.0015Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.658 62.652V75.7805H87.6629V62.652L76.1631 41.2314H85.1452C85.1452 41.2314 91.4135 54.0145 91.66 54.8045L98.1757 41.2314H107.108L95.658 62.652Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.951 75.7804L128.135 41.2313H120.435L102.251 75.7804H109.951Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_274_1078">
          <rect width="128.14" height="76" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ThisWaySvgIcon;
